import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { maxConsecutiveAlphabetRunLength } from '../wordAnalysis'

export const straightCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return (
    isAcceptedWordEntry(entry) && maxConsecutiveAlphabetRunLength(entry.word) >= 3
  )
}
